import { render } from "./inspectionManagement.vue?vue&type=template&id=7d7c445b&scoped=true"
import script from "./inspectionManagement.vue?vue&type=script&lang=js"
export * from "./inspectionManagement.vue?vue&type=script&lang=js"

import "./inspectionManagement.vue?vue&type=style&index=0&id=7d7c445b&scoped=scoped&lang=less"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7c445b"]])

export default __exports__